import React from 'react';
import { observer } from 'mobx-react';

import { Form } from 'libs/forms/index';
import { Modal } from 'apps/modals/views/modal';
import { ModalTitle } from 'legacyComponents/styled/lib';
import { modalStore } from 'apps/modals/app';
import { Trans } from 'react-i18next';
@observer
export class EditTagsForm extends Modal {
  render() {
    const { app } = modalStore.props;
    const { editTagsFormStore } = app;
    const {
      conf: { formTitle },
    } = editTagsFormStore;
    return (
      <>
        <ModalTitle level={2}>
          <Trans>{formTitle}</Trans>
        </ModalTitle>
        <Form
          formStore={editTagsFormStore}
          formTitle=''
          buttonHandler={app.DoneEditingTags}
          noBorder={true}
          padding='0'
          responsive
        />
      </>
    );
  }
}
